<template>
	<a-config-provider :locale="zhCN">
		<div class="app">
			<router-view />
		</div>
	</a-config-provider>
</template>

<script setup>
	import zhCN from "ant-design-vue/es/locale/zh_CN";
	import { onMounted } from "vue";

	const getPopupContainer = (el, dialogContext) => {
		if (el) {
			return el.parentNode;
		} else {
			return document.body;
		}
	};

	onMounted(() => {
		document.title = "储能精算师";
	});
</script>

<style>
	* {
		box-sizing: border-box;
	}
</style>
